module.exports = {
  EN: "EN",
  ES: "ES",
  es: "es",
  en: "en-US",
  enPath: "-en",
  esPath: "-es",
  moltinLanguageCode: {
    'en-US': 'en',
    'es': 'es'
  }
}
